var template = require('./profile_email.html.slim');
declare var angular;

export class ProfileEmailController {
  static $inject = ['ProfileEmailStatus', 'users', '$routeParams']

  emailAddress;
  emailConfirmed;
  userIsStaff;
  isMigrated;
  stateLoaded = false;

  constructor(private ProfileEmailStatus, private users, private $routeParams) {
    this.userIsStaff = users.hasRole('staff');

    Promise.all([this.getIsMigrated(), this.getEmailDetails()])
      .finally(() => this.stateLoaded = true)
  }

  public getIsMigrated() {
    return this.users.isMigrated(this.users.getCurrentUser().email)
      .then(() => this.isMigrated = true)
      .catch(() => this.isMigrated = false)
  }

  public getEmailDetails() {
    return this.ProfileEmailStatus.get({user_id: this.$routeParams.userId}).$promise.then(
      (response) => {
        this.emailAddress = response.emailAddress
        this.emailConfirmed = response.emailConfirmed
      }
    )
  }

  public goToWorkflow() {
    window.location.assign('/app/email/new');
  }

  public goToResend() {
    window.location.assign('/app/email/verify');
  }
}

angular.module('wbComponents')
  .controller("ProfileEmailController", ProfileEmailController)
  .directive('profileEmail', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      controller: "ProfileEmailController",
      controllerAs: 'ctrl',
      replace: true,
    }
  });
